module.exports = __webpack_public_path__ + "static/media/w_sort_collapse.3d5a0c15.svg";